<section>
  <section>
    <h4 style="font-size: 100%; font-weight: 700">
      {{ customer!.firstName }} {{ customer!.lastName }}
      <!--
      <span class="text-right">
        <app-add-button
          [button]="customerButton"
          (buttonClick)="editCustomer(customer!)"
        ></app-add-button>
      </span>
      -->
    </h4>
    <div class="mb-2">
      {{ customer!.personalId }}
      {{ customer!.gender | settingValue: genderSettings }}
    </div>
    @if (customerContactInfo) {
      <section>
        <div class="grid">
          <div class="col-6">
            <label>{{ 'contact.phone' | translate }}</label
            ><br />
            <div>{{ customerContactInfo.phone }}</div>
          </div>
          <div class="col-6">
            <label>{{ 'contact.address' | translate }}</label
            ><br />
            <div>
              {{ customerContactInfo.address }}<br />
              {{ customerContactInfo.postCode }}
              {{ customerContactInfo.city }}
            </div>
          </div>
          <div class="col-12">
            <label>{{ 'common.email' | translate }}</label>
            <div>{{ customerContactInfo.email }}</div>
          </div>
        </div>
      </section>
    }
    @if (latestInProgressTreatment) {
      <button
        pButton
        type="button"
        class="mt-2"
        style="background-color: #1dfc92; border-color: #1dfc92; color: #07004d"
        (click)="openTreatmentCycle(latestInProgressTreatment)"
      >
        {{ latestInProgressTreatment.treatmentNumber }}
        {{ latestInProgressTreatment.specification }}
      </button>
    }
  </section>

  @if (partner) {
    <section>
      <hr />
      <h4 style="font-size: 100%; font-weight: 700">
        {{ partner.firstName }} {{ partner.lastName }}
      </h4>
      <div class="mb-2">
        {{ partner.personalId }}
        {{ partner.gender | settingValue: genderSettings }}
      </div>
      @if (partnerContactInfo) {
        <section>
          <div class="grid">
            <div class="col-6">
              <label>{{ 'contact.phone' | translate }}</label
              ><br />
              <div>{{ partnerContactInfo.phone }}</div>
            </div>
            <div class="col-6">
              <label>{{ 'contact.address' | translate }}</label
              ><br />
              <div>
                {{ partnerContactInfo.address }}<br />
                {{ partnerContactInfo.postCode }}
                {{ partnerContactInfo.city }}
              </div>
            </div>
            <div class="col-12">
              <label>{{ 'common.email' | translate }}</label>
              <div>{{ partnerContactInfo.email }}</div>
            </div>
          </div>
        </section>
      }
    </section>
  }
</section>
